import styled from 'styled-components';

export const H2 = styled.h2`
  font-size: 20px;
  flex: 1;
  cursor: default;
`;
